import { render, staticRenderFns } from "./PointNetridecashTechcoinStore.vue?vue&type=template&id=08cd524a"
import script from "./PointNetridecashTechcoinStore.vue?vue&type=script&lang=js"
export * from "./PointNetridecashTechcoinStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports